import styled, { css } from 'styled-components';
import { RiDeleteBin6Line } from 'react-icons/ri';
import { LoadingSpinner } from 'styles/sharedStyles';

const IframeHeight = '750px';
const iconHover = css`
  cursor: pointer;
  padding: 10px;
  line-height: 0;
  border-radius: 50%;

  transition: all 0.2s ease-in-out;

  &:hover {
    background-color: rgba(0, 0, 0, 0.04);
  }
`;

export const ThumbnailContainer = styled.div`
  padding: 5px 0;
`;

export const Thumbnail = styled.div`
  display: flex;
  align-items: center;
  width: fit-content;

  overflow: hidden;

  > img {
    cursor: pointer;
  }
`;

export const EditIcon = styled.div`
  margin: 0 0 0 10px;
  ${iconHover}
`;

export const Status = styled.div``;

export const IconsContainer = styled.div<{ $isDeleting?: boolean }>`
  display: flex;
  justify-content: flex-end;

  pointer-events: ${({ $isDeleting }) => ($isDeleting ? 'none' : 'auto')};
`;

export const DeleteIcon = styled(RiDeleteBin6Line)`
  ${iconHover}
`;

export const DeleteLoadingSpinner = styled(LoadingSpinner)`
  ${iconHover};
  padding: unset;
  margin: 10px;
  border-radius: 50%;
  line-height: 0;
`;

export const ActionButtons = styled.div`
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  box-sizing: border-box;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;

  > span {
    font-size: 1.5rem;
    font-weight: 500;
    margin-left: 10px;
  }
`;

export const ModalBody = styled.div`
  display: flex;
  flex-direction: row;
  background-color: #f1f2f4;
  position: relative;
`;

export const ModalFooter = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: #f1f2f4;
`;

export const IframeContainer = styled.div`
  width: 75%;
  position: relative;
`;

export const CloseButtonWrapper = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

export const ProductDetailsContainer = styled.div`
  width: 25%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  :last-child {
    margin-bottom: 0;
  }
`;

export const Iframe = styled.div`
  height: ${IframeHeight};
  width: 100%;
`;

export const IframeDisabledOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 75%;
  height: ${IframeHeight};
  background: rgba(0, 0, 0, 0.44);
`;

export const StatusMessage = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(2, 119, 180, 1);
  color: white;
`;

export const ProjectNameContainer = styled.div`
  position: absolute;
  backdrop-filter: blur(6px);
  top: 0;
  display: flex;
  height: ${IframeHeight};
  width: 100%;
  align-items: center;
`;

export const ProjectNameWrapper = styled.div`
  width: 20%;
  padding: 1.5%;
  background: white;
  border-radius: 5px;
  margin: 30%;
`;

export const Title = styled.div`
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
`;

export const Description = styled.div`
  font-weight: 400;
  font-size: 0.95rem;
  color: rgba(0, 0, 0, 0.63);
  margin-top: 1%;
  margin-bottom: 2%;
`;

export const InputWrapper = styled.div`
  margin: 20px 0;
`;
export const ButtonWrapper = styled.div`
  text-align: right;
`;

export const Section = styled.div`
  background-color: white;
  padding: 15px;
  margin: 5%;
  border-radius: 5px;
`;

export const RequirementList = styled.ul`
  margin: unset;
  padding-left: 25px;
  > * {
    line-height: 1.4;
  }
`;
export const RequirementListItem = styled.li`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
`;
export const Link = styled.a`
  color: rgba(32, 154, 214, 1);
  display: inline;
`;

export const ProductName = styled.div`
  font-weight: 500;
  font-size: 20px;
  line-height: 28px;
`;

export const ProductSKU = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  margin: 10px 0 15px 0;
`;

export const ProductPrice = styled.div`
  font-weight: 500;
  font-size: 24px;
  line-height: 32px;
  margin: 10px 0 15px 0;
`;

export const AddToCartSection = styled.div`
  margin: 10px 10px 10px 0;
  display: flex;
  flex-direction: column;
  > button {
    margin-top: 10px;
  }
`;

// export const DownloadSection = styled.div`
//   margin: 10px;
//   display: flex;
//   flex-direction: row;
//   align-items: center;
//   justify-content: right;
// `;
